import { ProgressIndicatorComponent, progressIndicatorTemplate } from './ProgressIndicator';
import styles from './ProgressIndicator.styles.scss';
export const progressIndicatorDefinition = {
    baseName: 'progress-indicator',
    template: progressIndicatorTemplate,
    styles,
};
export const chameleonProgressIndicator = ProgressIndicatorComponent.compose(progressIndicatorDefinition);
